export const ShinyBox = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className="p-8 backdrop-blur rounded-2xl shadow-lg max-w-md w-full flex flex-col items-center border border-white/10 bg-gradient-to-br from-black via-gray-900 to-black animate-gradient">
			{children}
		</div>
	)
}
